import React from "react";
import { useTranslation } from "react-i18next";

const Card = ({ icon, title, description, link }) => {
    const { t } = useTranslation();

    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="card border-2 text-decoration-none h-100"
            style={{
                borderColor: "aliceblue",
                transition: "transform 0.3s, box-shadow 0.3s",
                cursor: "pointer",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.classList.add("shadow");
                e.currentTarget.style.transform = "translateY(-4px)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.classList.remove("shadow");
                e.currentTarget.style.transform = "translateY(0)";
            }}
        >
            <div className="d-flex justify-content-center align-items-center bg-aliceblue p-4">
                <img
                    src={icon}
                    alt={`${title} Icon`}
                    className="img-fluid"
                    style={{ height: "120px", width: "auto", margin: "20px auto" }}
                />
            </div>
            <div className="card-body">
                <h2 className="fs-3 text-primary mb-3 fw-semibold">{title}</h2>
                <p className="fs-5 text-secondary">{description}</p>
                <span className="text-primary fw-bold" style={{ fontSize: "1.1rem" }}>
                    {t("open").toUpperCase()} →
                </span>
            </div>
        </a>
    );
};

export default Card;
